import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function(){
	const slidingTabs = document.querySelector('[data-block="sliding-tabs"]');
	const tabsContent = document.querySelectorAll('[data-name="tabs-content"]');
	const tabsButtons = document.querySelector('[data-name="tabs-buttons"]');

	if ( ! tabsButtons || ! tabsContent ) return;

	// Preparation
	gsap.set( tabsButtons, { autoAlpha: 0 } );

	const totalTabs = tabsContent.length;
	let tallestContentHeight = 0;
	tabsContent.forEach(content => {
		const contentHeight = content.offsetHeight;
		if ( contentHeight > tallestContentHeight ) {
			tallestContentHeight = contentHeight;
		}
	});
	tabsContent.forEach(content => {
		gsap.set(content, { height: tallestContentHeight });
	});

	tabsContent.forEach((content, index) => {
		gsap.set( content, { zIndex: totalTabs - index } )
		if ( index !== 0 ) {
			gsap.set( content, { marginTop: `-${ tallestContentHeight + 12}px` } )
		}
		gsap.set( content.querySelector('& > div'), {  scale: `${1 - (index * 0.05) }`, transformOrigin: 'top center' } );
	});
	
	/* Animations */
	// Animation on load
	const loadTl = gsap.timeline({
		scrollTrigger: {
			trigger: tabsButtons,
			start: 'top center',
			end: 'bottom bottom',
			//markers: true,
		},
	});

	loadTl
		.fromTo( tabsContent, { y: '100%' }, { y: '0%', duration: 1, stagger: 0.2 } )
		.to( tabsButtons, { autoAlpha: 1, duration: 1 } );
		
	// Animation on scroll	
	const scrollTl = gsap.timeline({
		scrollTrigger: {
			trigger: slidingTabs,
			start: window.innerWidth < 992 ? 'top top+=100px' : 'top top+=50px',
			endTrigger: tabsContent[totalTabs - 1],
			end: `bottom bottom-=${(totalTabs + 1) * tallestContentHeight}px`,
			scrub: 0.7,
			pin: true,
			anticipatePin: 1,
			//markers: true,
		},
	});

	// Update the active tab based on scroll position
	scrollTl.scrollTrigger?.animation.eventCallback("onUpdate", () => {
		const progress = scrollTl.progress();
		const step = Math.floor(progress * totalTabs);

		tabsContent.forEach((el, idx) => {
			if (idx === step) {
				let buttonIndex = el.getAttribute('data-index')
				tabsButtons.querySelector('button.active').classList.remove('active');
				tabsButtons.querySelector(`button[data-index="${buttonIndex}"]`).classList.add('active');

				el.classList.add('active');
			} else {
				el.classList.remove('active');
			}
		});
	});

	scrollTl
		.to(Array.from(tabsContent).map(content => content.querySelector(':scope > div')), { scale: 1, transformOrigin: 'top center', duration: 1, stagger: 1 })
		.to(Array.from(tabsContent).slice(0, -1), { y: '-150%', duration: 1, stagger: 1 }, "0.5")
		.to(Array.from(tabsContent).slice(0, -1), { autoAlpha: 0, duration: 1, stagger: 1 }, "<0.5")


	// Click on tabs
	tabsButtons.querySelectorAll('button')?.forEach(button => {
		button.addEventListener('click', () => {
			const buttonIndex = button.getAttribute('data-index');
			const buttonActiveIndex = tabsButtons.querySelector('button.active').getAttribute('data-index');
			let tabsContentToMove

			tabsButtons.querySelector('button.active').classList.remove('active');
			button.classList.add('active');
			
			if (  buttonIndex > buttonActiveIndex ) {
				tabsContentToMove = Array.from(tabsContent).slice(buttonActiveIndex - 1, buttonIndex - 1);

				gsap.to(tabsContentToMove, { y: '-150%', duration: 0.3, stagger: 0.3 })
				gsap.to(tabsContentToMove, { autoAlpha: 0, duration: 0.3, stagger: 0.3 })
			} else {
				tabsContentToMove = Array.from(tabsContent).slice(buttonIndex - 1, buttonActiveIndex - 1);
				
				gsap.to(tabsContentToMove, { autoAlpha: 1, duration: 0, stagger: 0.3 })
				gsap.to(tabsContentToMove, { y: '0%', duration: 0.3, stagger: 0.3 })
			}

		});
	});
	
}







